import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarPointV1Response } from './get-grammar-point-v1-response';
import { getGrammarPointV1ResponseSchema } from './get-grammar-point-v1-response';

export async function getGrammarPointV1Api(
  slug: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarPointV1Response>> {
  return getRequest<IGetGrammarPointV1Response>({
    path: `/grammar/points/${encodeURIComponent(slug)}/v1`,
    schema: getGrammarPointV1ResponseSchema,
    options,
  });
}
